import { API_BASE_URL } from "../../constant/constant";
import { useState, useRef, useEffect } from "react";
import {
    ScrollableChat,
    LoadingText,
    ChattingLoadingBox,
} from "../Summarize/Style";
import ArrowUpIcon from "../../assets/arrow-up.svg";
import ReactMarkdown from 'react-markdown';
import { ChatBox, Content } from "./style";
import { useTranslation } from "react-i18next";

const DatabaseChat = ({ messages, setMessages, isChatting, avatarData }) => {
    const [loadingHistory, setLoadingHistory] = useState(false);
    const userId = localStorage.getItem("id");
    const scrollableChatRef = useRef(null);
    const { t } = useTranslation();

    useEffect(() => {
        messages?.length === 0 ? fetchChatHistory() : null
    }, []);

    const fetchChatHistory = async () => {
        try {
            setLoadingHistory(true)
            const response = await fetch(
                `${API_BASE_URL}/api/auth/get-chats?user_id=${userId}`
            );
            const data = await response.json();

            const chatHistory = data.chats.map((chat) => [
                { role: "USER", content: chat.query, sourceDocuments: chat.sourceDocuments, sourceChunks: chat.sourceChunks },
                { role: "ASSISTANT", content: chat.content },
            ]).flat();

            setMessages(chatHistory);
        } catch (error) {
            console.error("Failed to load chat history:", error);
        } finally {
            setLoadingHistory(false);
        }
    };

    useEffect(() => {
        if (scrollableChatRef.current) {
            scrollableChatRef.current.scrollTop =
                scrollableChatRef.current.scrollHeight;
        }
    }, [messages]);

    return (
        <Content
            style={{
                height: "calc(100vh - 252px)",
                // overflowY: "auto"
            }}
        >
            {loadingHistory ? (
                <div style={{ display: "flex", justifyContent: "center" }}>
                    <LoadingText>{t("avatarChat.loadingHistory")}</LoadingText>
                </div>
            ) : (
                <>
                    {
                        messages.length === 0 ? (
                            <div style={{ textAlign: "center", color: "#666", marginTop: "2rem", height: "100%" }}>
                                {t("avatarChat.noMessages")}
                            </div>
                        ) : (
                            <ChatBox>
                                <ScrollableChat ref={scrollableChatRef}>
                                    {messages.map((msg, index) => {
                                        const isUser = msg.role === "USER";
                                        console.log("message: ", msg)

                                        return (
                                            <div
                                                key={index}
                                                style={{
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    alignItems: isUser ? "flex-end" : "flex-start",
                                                    marginBottom: "1rem",
                                                    width: "100%",
                                                }}
                                            >
                                                {/* Sender name + time */}
                                                <div
                                                    style={{
                                                        fontSize: "0.75rem",
                                                        color: "#666",
                                                        marginBottom: "0.25rem",
                                                    }}
                                                >
                                                    {isUser ? "You" : avatarData?.avatarName || "Bot"}
                                                </div>

                                                {/* Chat bubble */}
                                                <div
                                                    style={{
                                                        background: isUser ? "#202226" : "#FFFFFF",
                                                        color: isUser ? "#fff" : "#000",
                                                        padding: "0.75rem 1rem",
                                                        borderRadius: "12px",
                                                        maxWidth: "70%",
                                                        wordBreak: "break-word",
                                                        fontSize: "0.95rem",
                                                        lineHeight: "1.4",
                                                        overflowWrap: "break-word",
                                                        whiteSpace: "pre-wrap",
                                                    }}
                                                >
                                                    <ReactMarkdown
                                                        components={{
                                                            code({ node, inline, className, children, ...props }) {
                                                                return (
                                                                    <code
                                                                        style={{
                                                                            whiteSpace: "pre-wrap",
                                                                            wordBreak: "break-word",
                                                                            background: "#f5f5f5",
                                                                            padding: inline ? "2px 4px" : "8px",
                                                                            borderRadius: "6px",
                                                                            display: inline ? "inline" : "block",
                                                                            fontSize: "0.85rem",
                                                                            maxWidth: "100%",
                                                                            overflowX: "auto",
                                                                        }}
                                                                        {...props}
                                                                    >
                                                                        {children}
                                                                    </code>
                                                                );
                                                            },
                                                        }}
                                                    >
                                                        {msg.content}
                                                    </ReactMarkdown>
                                                </div>
                                            </div>
                                        );
                                    })}
                                    {isChatting && <ChattingLoadingBox>
                                        Loading
                                        <span></span>
                                        <span></span>
                                        <span></span>
                                    </ChattingLoadingBox>}
                                </ScrollableChat>
                            </ChatBox>
                        )
                    }

                </>
            )}


        </Content>

    );
};

export default DatabaseChat;